import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { SET_CUSTOM_SKILL_SELECTED, SET_ONBOARDING_SELECTED_SKILL, SET_ONBOARDING_STEP } from '../../redux/actions/types';
import { Mixpanel } from '../../config/Mixpanel';
import Constants from '../../common/constants';


const RecommendedCourses = () => {

    const [selectedValue, setSelectedValue] = useState("");
    const relatedSubjects = useSelector((store) => store?.onBoarding?.relatedSubjects);
    const relatedPersonalisedSkills = useSelector((store) => store?.onBoarding?.relatedPersonalisedSkills);
    const isPersonalisedSkillsLoading = useSelector((store) => store?.onBoarding?.isPersonalisedSkillsLoading);
    const dispatch = useDispatch();

    const handleSelect = (option) => {
      Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_FIFTH_STEP_CUSTOM_CARD_CLICKED);
        setSelectedValue(option);
        dispatch({type : SET_CUSTOM_SKILL_SELECTED, payload : true});
        dispatch({type : SET_ONBOARDING_SELECTED_SKILL, payload : {'id' : 0 , 'skill-name' : option}});
        dispatch({type : SET_ONBOARDING_STEP, payload : 6});
    }
  const getTagForIndex = (index) => {
    if (index === 0) return { text: "Expert-Recommended", gradient: "bg-gradient-to-r from-[#2BBD13] to-[#0B1D2B]" };
    if (index === 2) return { text: "Most Popular", gradient: "bg-gradient-to-r from-[#6a6a6a] to-[#0B1D2B]" };
    if (index === 4) return { text: "Industry-Preferred", gradient: "bg-gradient-to-r from-[#EF9121] to-[#0B1D2B]" };
    return null;
  };

  const getCourses = useCallback(() => {
    if(relatedPersonalisedSkills?.length >=5 ){
      return relatedPersonalisedSkills;
    }
    return [...relatedPersonalisedSkills, ...relatedSubjects]?.slice(0, 5);
  }, [relatedSubjects, relatedPersonalisedSkills]);

  // Skeleton loader component
  const SkeletonCard = () => (
    <div className="w-full flex items-center justify-between rounded-xl px-4 py-4 bg-[#406aff1a] animate-pulse">
      <div className="w-full inline-flex flex-1 flex-col items-start justify-center gap-3">
        <div className="w-full inline-flex items-center gap-2">
          <div className="flex-shrink-0 w-[34px] h-[30px] bg-white/20 rounded"></div>
          <div className="flex flex-col text-left mr-4 gap-3 flex-1">
            <div className="h-4 bg-white/20 rounded w-3/4"></div>
            <div className="h-3 bg-white/20 rounded w-1/2"></div>
          </div>
        </div>
      </div>
      <div className="h-4 w-4 rounded-full border-2 border-white/20"></div>
    </div>
  );

  return (
    <div className="mx-auto w-full flex flex-col  gap-3">
    {isPersonalisedSkillsLoading ? (
      // Show 5 skeleton loaders while loading
      Array(5).fill(0).map((_, index) => <SkeletonCard key={index} />)
    ) : (
      getCourses()?.map((option, index) => {
      const tag = getTagForIndex(index);
      return (
      <label
        key={option.id}
        htmlFor={option.id}
        className={`w-full flex cursor-pointer items-center justify-between rounded-xl px-4 py-4 transition-all relative ${
          selectedValue === option
            ? "border-[0.7px] border-solid border-[#7fc241] bg-[#406aff33] shadow-[0px_0px_20px_#000000b2]"
            : "bg-[#406aff1a]"
        }`}
        onClick={() => handleSelect(option)}
      >
        {tag && (
          <div className={`absolute top-0 left-0 rounded-tl-xl rounded-br-xl ${tag.gradient} px-[6px] py-[2px] z-10`}>
            <span className="text-white text-[10px] font-medium leading-none">{tag.text}</span>
          </div>
        )}
        <div className={`w-full inline-flex flex-1 flex-col items-start justify-center gap-3 ${tag ? 'pt-6' : ''}`}>
          <div className="w-full inline-flex items-center gap-2">
            {(
              <img
                className={`flex-shrink-0 w-[34px] h-[30px]`}
                alt={option}
                src={'https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/Group%2023366.png'}
              />
            )}

            <div className="flex flex-col text-left mr-4 leading-[120%] justify-center items-start gap-3 font-normal  tracking-[0] [font-family:'Inter',Helvetica]">
              <span className="text-[#70AEFF] font-semibold text-[14px] leading-[120%]">
                {option}
              </span>
              <div className='text-white/70 font-normal text-[10px]'> <FontAwesomeIcon icon={faStar} className='text-[#F5B631]'/> 4.8/5 Course Rating</div>
            </div>
          </div>
        </div>

        <div className="relative">
          <div
            className={`h-4 w-4 cursor-pointer rounded-full flex justify-center items-center border-2 transition-all ${
              selectedValue === option
                ? "border-[#7fc241] p-[3px]"
                : "border-[#7fc241] bg-transparent"
            }`}
            onClick={() => handleSelect(option)}
          >
            {selectedValue === option && (
              <div className="h-full w-full rounded-full bg-[#7fc241]"></div>
            )}
          </div>
        </div>
      </label>
      );
    })
    )}
  </div>
  )
}

export default RecommendedCourses